import {isNil} from 'ramda';

const CENTER_DIVISOR = 2;
/** Matches the hour/minute `List`, the nearest listbox above an option. */
const LIST_SELECTOR = '[role="listbox"]';

/**
 * Centers a time option inside its own hour/minute list.
 *
 * `Element.scrollIntoView` must not be used here: it scrolls every scrollable ancestor, so
 * opening the dropdown would also scroll the surrounding page (in DMS `#dms-app-container`)
 * until the dropdown sits in the middle of the viewport, yanking the field away from the user.
 *
 * Resolves the list the same way `useTimePickerAutoScroll` does, so both scroll paths keep
 * working off one DOM contract.
 */
export function scrollOptionIntoList(option: HTMLElement | null) {
  if (isNil(option)) {
    return;
  }

  const list = option.closest(LIST_SELECTOR);

  if (isNil(list)) {
    return;
  }

  const optionRect = option.getBoundingClientRect();
  const listRect = list.getBoundingClientRect();
  const offsetFromListTop = optionRect.top - listRect.top;
  const centeredOffset = (listRect.height - optionRect.height) / CENTER_DIVISOR;

  list.scrollTop += offsetFromListTop - centeredOffset;
}
